// @flow

import { push } from 'connected-react-router'

export function checkHttpStatus(response: {
  status: number,
  statusText: string
}): Object {
  if (response.status >= 200 && response.status < 300) {
    return response
  } else {
    const error: Object = new Error(response.statusText)
    error.response = response
    throw error
  }
}

export function checkForPolicyChanges(response: Object): Object {
  return response.headers.get('X-Policy-Changes')
}

export function getApiHeaders(state: { auth: { token: string } }): Object {
  return getApiHeadersFromToken(state.auth.token)
}

export function getApiHeadersFromToken(token: string): Object {
  return {
    Authorization: `Token token="${token}"`,
    Accept: 'application/json, application/vnd.oefngl.v4',
    'Content-Type': 'application/json'
  }
}

export function getApiBaseUrl(): string {
  return process.env.REACT_APP_API_BASE_URL
}

export function getApiBaseUrlWithOrg(orgId: number): string {
  return getApiBaseUrl() + `/api/organizations/${orgId}`
}

export async function basicGet(
  state: Object,
  dispatch: Function,
  url: string,
  request: Function,
  success: Function,
  failure: ?Function
) {
  dispatch(request())

  try {
    const response = checkHttpStatus(
      await fetch(url, {
        method: 'GET',
        headers: getApiHeaders(state)
      })
    )
    const data = await response.json()
    dispatch(success(data))
  } catch (error) {
    if (failure) {
      dispatch(failure(error))
    }

    if (error.response.status === 404) {
      dispatch(push('/notfound'))
    }

    if (error.response.status === 500) {
      dispatch(push('/error'))
    }
  }
}

export async function basicGetResponseOnly(
  state: Object,
  dispatch: Function,
  url: string
) {
  const response = checkHttpStatus(
    await fetch(url, {
      method: 'GET',
      headers: getApiHeaders(state)
    })
  )
  return await response.json()
}
